import { FC } from 'react'

import styled from 'styled-components'

import { capitalizeFirstLetter } from 'src/Helpers/layoutHelpers'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { ScheduleSteps } from 'src/Components/PrimaryScheduleTabs'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { ModalType } from 'src/Types/ui'
import { AddParameterButton } from 'src/Components/Buttons/AddParameterButton'

import { AdsAdSettingsProps } from './index'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`
const ContainerWithError = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
`

const SubTitle = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const CountriesList = styled(SubTitle)`
  font-weight: 400;
`

interface AddTargetLocationsControlsProps {
  countries: AdsAdSettingsProps['countries']
}

export const AddTargetLocationsControls: FC<
  AddTargetLocationsControlsProps
> = ({ countries }) => {
  const { setSearch } = useCustomSearchParams()

  const handleClick = (): void => {
    const query = {
      step: ScheduleSteps.SETTINGS,
      modal: ModalType.Countries,
    }
    setSearch(query)
  }

  if (!countries || countries.length === 0) {
    return (
      <AddParameterButton onClick={handleClick}>
        <span>Add target locations</span>
      </AddParameterButton>
    )
  }
  const countriesString = countries
    .map((country) => capitalizeFirstLetter(country || ''))
    .join(', ')

  return (
    <Container>
      <ContainerWithError>
        <Wrapper>
          <SubTitle>Target locations</SubTitle>
          <CountriesList translate='no'>{countriesString}</CountriesList>
        </Wrapper>
        <PrimaryDottedButton onClick={handleClick}>Edit</PrimaryDottedButton>
      </ContainerWithError>
    </Container>
  )
}
